module.exports = __webpack_public_path__ + "img/diabolical_dr_z_mobile.afb747cd.jpg";